import { Product } from 'graphql-api/gql-api-interfaces';
import { ProductBasketProviderResultType } from '../lists';
import { SingleProductDataType } from '../types/single-product-data-type';
import { MediaType } from '@epicuro-next/models/engagement';

export function mapSearchResultsToProductData([
  searchUrl,
  searchResults,
  maxNrOfProductsToShow,
  imgToUse,
  shuffle = false,
  excludeProduct = '',
]: [
  string,
  ProductBasketProviderResultType,
  number | string | undefined,
  string,
  boolean,
  string,
]): SingleProductDataType[] {
  const productsData: SingleProductDataType[] = [];
  let productsToMap =
    searchResults.products.filter(
      (product) => product.productId !== excludeProduct,
    ) ?? [];

  function shuffleArray(array: any[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  if (shuffle) {
    productsToMap = shuffleArray(productsToMap);
  }

  if (maxNrOfProductsToShow !== undefined) {
    if (typeof maxNrOfProductsToShow === 'string') {
      maxNrOfProductsToShow = parseInt(maxNrOfProductsToShow, 10);
    }

    if (maxNrOfProductsToShow > 0) {
      productsToMap = productsToMap.slice(0, maxNrOfProductsToShow);
    }
  }

  imgToUse = imgToUse.trim().toLowerCase();
  enum ImageToUse {
    article = 'article',
    main = 'main',
  }

  const getImgFunc = (product: Product) => {
    if (imgToUse.includes(ImageToUse.article)) {
      return product.articleImageUrl ?? product.mainImageUrl;
    }

    return (product.mainImageUrl as string) ?? product.articleImageUrl;
  };

  for (const product of productsToMap) {
    const productData: SingleProductDataType = {
      media: {
        mediaType: 'image' as MediaType,
        url: getImgFunc(product),
      },
      product,
      attributionToken: null,
      correlationId: null,
      providerId: 'ProductSearch',
      servingConfig: searchUrl,
      hash: null,
      configStrip: {
        overlayPath: [
          'cs',
          product.brandId,
          product.parentId as string,
          product.productId,
        ],
      },
    };
    productsData.push(productData);
  }

  return productsData;
}
